import React from "react";
import { Box, Typography, styled, useMediaQuery, useTheme, Stack } from "@mui/material";

const StatusIndicator = styled("div")(({ active }) => ({
  width: 28,
  height: 16,
  position: "relative",
  display: "inline-block",
  backgroundColor: active ? "#AFE04D" : "#f44336", // Green if active, red if inactive
  borderRadius: "8px",
  "&::before": {
    content: '""',
    position: "absolute",
    width: 16,
    height: 16,
    backgroundColor: "white",
    borderRadius: "50%",
    top: 0,
    left: active ? 12 : 0,
    transition: "left 0.3s",
  },
}));

const RouteDetails = ({ details }) => {
  const { route, vehicle, speed } = details;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <Box
      sx={{
        backgroundColor: "#192f60",
        color: "white",
        padding: { xs: "12px 16px", sm: "12px 20px" },
        width: "100%",
        borderRadius: "4px",
        marginTop: "30px",
      }}
    >
      <Stack 
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 2, md: 0 }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        sx={{ width: "100%" }}
      >
        {/* Route Name */}
        <Box sx={{ 
          width: { xs: "100%", md: "auto" },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          mb: { xs: 1, sm: 0 }
        }}>
          <Typography 
            component="span" 
            fontWeight="500" 
            sx={{ 
              mr: { xs: 0, sm: 0.5 },
              mb: { xs: 0.5, sm: 0 }
            }}
          >
            Route Name:
          </Typography>
          <Typography 
            component="span"
            sx={{
              ml: { sm: 1 },
              fontWeight: "400"
            }}
          >
            {route.name}
          </Typography>
        </Box>

        {/* Speed */}
        <Box sx={{ 
          width: { xs: "100%", md: "auto" },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          mb: { xs: 1, sm: 0 }
        }}>
          <Typography 
            component="span" 
            fontWeight="500" 
            sx={{ 
              mr: { xs: 0, sm: 0.5 },
              mb: { xs: 0.5, sm: 0 }
            }}
          >
            Estimated Speed:
          </Typography>
          <Typography 
            component="span"
            sx={{
              ml: { sm: 1 },
              fontWeight: "400"
            }}
          >
            {speed} km/h
          </Typography>
        </Box>

        {/* Vehicle Status */}
        <Box sx={{ 
          width: { xs: "100%", md: "auto" },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" }
        }}>
          <Typography 
            component="span" 
            fontWeight="500" 
            sx={{ 
              mr: { xs: 0, sm: 1 },
              mb: { xs: 0.5, sm: 0 }
            }}
          >
            Status:
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: "16px",
              padding: "2px 8px 2px 12px",
              height: "24px",
              backgroundColor: vehicle.status ? "#a4d037" : "#f44336",
              mt: { xs: 0.5, sm: 0 }
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "white",
                fontWeight: 500,
                mr: 0.5,
                fontSize: "13px",
              }}
            >
              {vehicle.status ? "Active" : "Inactive"}
            </Typography>
            <StatusIndicator active={vehicle.status} />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default RouteDetails;